/**
 * @module FE-CU49_ユーザー情報変更画面_パスワード
 */
import Header from '../../../components/header/Header.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';

const PAGE_ID = 'FE-CU49';

export default {
  name: 'UserPasswordEdit',
  components: {
    Header,
    MobileFooter,
    PcPageTitle,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU49ユーザー情報変更画面パスワード.ユーザー情報変更'),
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.C0001'
      ),
      nowPassword: '',
      nowPasswordError: '',
      showNowPassword: false,
      newPassword: '',
      newPasswordError: '',
      showNewPassword: false,
      newPasswordCheck: '',
      newPasswordCheckError: '',
      showNewPasswordCheck: false,
      valid: false,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    nowPasswordRule() {
      return [
        !!this.nowPassword ||
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.E0001'
          ),
      ];
    },

    newPasswordRule() {
      if (this.newPassword === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.E0002'
          ),
        ];
      }

      if (this.newPassword.length < 8) {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.E0013'
          ),
        ];
      }

      if (
        /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*?[!-/:-@[-`{-~])|(?=.*[A-Z])(?=.*[0-9])(?=.*?[!-/:-@[-`{-~])|(?=.*[a-z])(?=.*[0-9])(?=.*?[!-/:-@[-`{-~]))([!-~]){8,}$/.test(
          this.newPassword
        )
      ) {
        return [true];
      } else {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.E0009'
          ),
        ];
      }
    },

    newPasswordCheckRule() {
      if (this.newPasswordCheck === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.E0003'
          ),
        ];
      }

      // パスワードがパスワード(確認用)と同一かどうかのバリデーションルール
      if (this.newPassword !== this.newPasswordCheck) {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.E0004'
          ),
        ];
      }

      if (this.newPasswordCheck.length < 8) {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.E0013'
          ),
        ];
      }

      if (
        /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*?[!-/:-@[-`{-~])|(?=.*[A-Z])(?=.*[0-9])(?=.*?[!-/:-@[-`{-~])|(?=.*[a-z])(?=.*[0-9])(?=.*?[!-/:-@[-`{-~]))([!-~]){8,}$/.test(
          this.newPasswordCheck
        )
      ) {
        return [true];
      } else {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.E0011'
          ),
        ];
      }
    },
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU49ユーザー情報変更画面パスワード.ユーザー情報変更'),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.C0001'
        ),
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * ユーザー情報更新（パスワード)API実行処理
     * @param {String} modified 更新日時
     */
    APP_CU4901: function (modified) {
      let param = '/api/changeUserInfoOfPassword/update';
      // let param = "post";
      let method = 'post';

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        beforePassword: this.nowPassword,
        afterPassword: this.newPassword,
        modified: modified,
      };

      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            // apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // レスポンスなし
            this.callMessageDialog(
              '$vuetify.FECU49ユーザー情報変更画面パスワード.変更が完了しました'
            );
          },
          (error) => {
            if (error.message.includes('400')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.E0005'
              );
            } else if (error.message.includes('401')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.E0012'
              );
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        );
    },
    /**
     * modified取得処理
     */
    APP_CU4701: function () {
      let param = '/api/changeUserInfoOfPersonalData/init';
      let method = 'post';
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
      };

      let apiData = '';
      let modified = '';
      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            modified = JSON.stringify(apiData.contentsInfo.modified);
            this.APP_CU4901(modified);
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
    },
    /**
     * メッセージ通知ダイアログ呼び出し処理
     * @param {String} text メッセージ
     */
    async callMessageDialog(text) {
      await this.$informationDialog(text);

      // FE-CU34 アカウント管理(ユーザー情報)画面に遷移
      this.$router.back('userInfoAccountManagement');
    },
    /**
     * 更新確認ダイアログ呼び出し処理
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU49ユーザー情報変更画面パスワード.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === true) {
        // はいを押すと更新処理実行
        this.APP_CU4701();
      }
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }
    //初期通信完了後に画面を表示
    this.isShowPage = true;
  },
};
